/**
 * @generated SignedSource<<892865b1c3f7229d7a9b0814d9bfb44c>>
 * @relayHash 2076bc7d8621db697b8017f9d03e1bde
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2076bc7d8621db697b8017f9d03e1bde

import { ConcreteRequest } from 'relay-runtime';
export type initialTimeZoneQuery$variables = Record<PropertyKey, never>;
export type initialTimeZoneQuery$data = {
  readonly timeZone: string;
};
export type initialTimeZoneQuery = {
  response: initialTimeZoneQuery$data;
  variables: initialTimeZoneQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "timeZone",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "initialTimeZoneQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "initialTimeZoneQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "2076bc7d8621db697b8017f9d03e1bde",
    "metadata": {},
    "name": "initialTimeZoneQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5874a79627fc08ae8a300956933bffdd";

export default node;
